import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import store from './store'
import TableFilterHeader from './components/TableFilterHeader.vue'

Vue.use(ElementUI)
// 全局注册表头筛选组件，所有 el-table-column 均可直接使用
Vue.component('TableFilterHeader', TableFilterHeader)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
